module.exports = {"220623100":"长白镇","220623101":"八道沟镇","220623102":"十四道沟镇","220623103":"马鹿沟镇","220623104":"宝泉山镇","220623105":"新房子镇","220623106":"十二道沟镇","220623200":"金华乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220623.json
// module id = 650
// module chunks = 0